var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2522_17093)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6 48H10.4C9.03351 48.0028 7.6799 47.7356 6.41688 47.2139C5.15387 46.6922 4.00629 45.9263 3.04002 44.96C2.07375 43.9937 1.30779 42.8462 0.786112 41.5832C0.26443 40.3201 -0.00270996 38.9665 2.07248e-05 37.6V10.4C-0.00270996 9.03351 0.26443 7.6799 0.786112 6.41688C1.30779 5.15387 2.07375 4.00629 3.04002 3.04002C4.00629 2.07375 5.15387 1.30779 6.41688 0.786112C7.6799 0.26443 9.03351 -0.00270996 10.4 2.07248e-05H37.6C38.9665 -0.00270996 40.3201 0.26443 41.5832 0.786112C42.8462 1.30779 43.9937 2.07375 44.96 3.04002C45.9263 4.00629 46.6922 5.15387 47.2139 6.41688C47.7356 7.6799 48.0028 9.03351 48 10.4V37.6C48.0028 38.9665 47.7356 40.3201 47.2139 41.5832C46.6922 42.8462 45.9263 43.9937 44.96 44.96C43.9937 45.9263 42.8462 46.6922 41.5832 47.2139C40.3201 47.7356 38.9665 48.0028 37.6 48Z",
    fill: "url(#paint0_linear_2522_17093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0806 25.5651H34.0891C34.0891 25.5651 30.8577 30.3051 28.1406 33.8279C25.792 36.8708 25.1063 39.4765 24.9091 40.7365C24.832 41.1994 24.4549 41.5422 24.0006 41.5422C23.5463 41.5422 23.1691 41.1994 23.092 40.7365C22.8949 39.4765 22.2091 36.8708 19.8606 33.8279C19.5006 33.3565 19.132 32.8679 18.7634 32.3708L27.6349 21.8279L34.7748 13.3594C35.5634 15.0137 36.0006 16.8651 36.0006 18.8279C36.0006 21.3137 35.2891 23.6194 34.0806 25.5651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6338 21.8281L18.7624 32.371C16.3453 29.131 13.911 25.5653 13.911 25.5653H13.9195C13.6624 25.1538 13.431 24.7338 13.2338 24.2967L20.3653 15.8281C19.6881 16.6424 19.2853 17.6881 19.2853 18.8281C19.2853 21.4338 21.3938 23.5424 23.9995 23.5424C25.4652 23.5424 26.7767 22.8738 27.6338 21.8281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7715 7.03468L20.4257 15.7604L14.8029 10.8575C16.9972 8.13182 20.3057 6.40039 24 6.40039C25.32 6.40039 26.5886 6.62325 27.7715 7.03468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4257 15.7603L20.3657 15.8288L13.2343 24.2974C12.4457 22.6431 12 20.7917 12 18.8288C12 15.7946 13.0543 13.0088 14.8029 10.8574L20.4257 15.7603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6343 21.8294C28.3114 21.0151 28.7143 19.9694 28.7143 18.8294C28.7143 16.2237 26.6057 14.1152 24 14.1152C22.5343 14.1152 21.2229 14.7837 20.3657 15.8294L27.7714 7.03516C30.8486 8.08087 33.3686 10.3866 34.7743 13.3609L27.6343 21.8294Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2522_17093",
    x1: 24,
    y1: -0.0519793,
    x2: 24,
    y2: 47.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C873F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B33BB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2522_17093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreas);
export default __webpack_public_path__ + "static/media/areas.13dc19d1fa00bb3c63087dbeece0d397.svg";
export { ForwardRef as ReactComponent };